export default "__VITE_ASSET__D3zGX57G__"